export default __webpack_public_path__ + "static/media/bo_3.e8ee92cc.mp3";